import React from 'react';
import { useParams } from 'react-router-dom';
import { WorkspaceAPI } from '../../../redux/stoerkID/StoerkIdAPI.model';
import { NavigationPath } from '../../DeviceManager/navigations/navigationPath';
import { getPolyglot } from '../../../i18n';
import WorkspaceName from './WorkspaceName';
import { WorkspaceRequestIdParams } from '../util/StoerkId.constants';

export function useNavigationPath(props: {
  workspace: WorkspaceAPI | undefined;
}): NavigationPath[] {
  const params = useParams<WorkspaceRequestIdParams>();
  const polyglot = getPolyglot();

  const isChildRoute = !!params.childId;
  const parentHref = isChildRoute
    ? params.workspaceId
      ? `/account/id/${params.workspaceId}`
      : '/account/my-account'
    : '/account/users';
  const parentLabel = isChildRoute
    ? polyglot.t('stoerk_id.nav_title')
    : polyglot.t('stoerk_id.customer_list.title');

  const sectionsNavigation: NavigationPath[] = [
    {
      content: parentLabel,
      href: parentHref,
      key: 'list-customers',
    },
    {
      content: <WorkspaceName workspace={props.workspace} />,
      href: `account/id/${params.childId ?? params.workspaceId}`,
      key: 'policy-create',
    },
  ];

  return sectionsNavigation;
}
